// extracted by mini-css-extract-plugin
export default {"link_button":"LinkButton_link_button__UAI5p","icon":"LinkButton_icon__SSX07"};